import React from 'react'

import './DrawerToggleButton.css'

const DrawerToggleButton = (props) => (
  <button className="toggle-button" onClick={props.click}>
    <span className="menu-line" />
    <span className="menu-line" />
    <span className="menu-line" />
  </button>
)

export default DrawerToggleButton
